import { Circle } from 'fabric';
import { lineControlStyles } from '@/config/options';

const makeCurveEnd = (left: number, top: number): Circle =>
  new Circle({
    left: left,
    top: top,
    ...lineControlStyles,
    // the control circles should not get the fabric editors
    hasBorders: true,
    hasControls: false,
    objectCaching: true,
    originX: 'center',
    originY: 'center',
  });

export default makeCurveEnd;
